import { action, createRequestTypes } from '../base';

export const manualProductionEntryActionTypes = {
  GET_MANUAL_PRODUCTION_ENTRIES: createRequestTypes('GET_MANUAL_PRODUCTION_ENTRIES'),
  GET_MANUAL_PRODUCTION_ENTRY_BY_ID: createRequestTypes('GET_MANUAL_PRODUCTION_ENTRY_BY_ID'),
  CREATE_MANUAL_PRODUCTION_ENTRY: createRequestTypes('CREATE_MANUAL_PRODUCTION_ENTRY'),
  UPDATE_MANUAL_PRODUCTION_ENTRY_STATUS: createRequestTypes('UPDATE_MANUAL_PRODUCTION_ENTRY_STATUS'),
  DELETE_MANUAL_PRODUCTION_ENTRY: createRequestTypes('DELETE_MANUAL_PRODUCTION_ENTRY'),
}

class ManualProductionEntryActions {

  // Get All
  getManualProductionEntries = (payload, callback) => action(manualProductionEntryActionTypes.GET_MANUAL_PRODUCTION_ENTRIES.REQUEST, {
    payload, callback
  })

  getManualProductionEntriesLoading = (getManualProductionEntryLoading) => action(manualProductionEntryActionTypes.GET_MANUAL_PRODUCTION_ENTRIES.LOADING, {
    getManualProductionEntryLoading
  })

  getManualProductionEntriesSuccess = (manualProductionEntries) => action(manualProductionEntryActionTypes.GET_MANUAL_PRODUCTION_ENTRIES.SUCCESS, {
    manualProductionEntries,
  })

  // Get By Id
  getManualProductionEntryById = (payload, callback) => action(manualProductionEntryActionTypes.GET_MANUAL_PRODUCTION_ENTRY_BY_ID.REQUEST, {
    payload, callback
  })

  getManualProductionEntryByIdLoading = (getManualProductionEntryByIdLoading) => action(manualProductionEntryActionTypes.GET_MANUAL_PRODUCTION_ENTRY_BY_ID.LOADING, {
    getManualProductionEntryByIdLoading
  })

  getManualProductionEntryByIdSuccess = (selectedManualProductionEntry) => action(manualProductionEntryActionTypes.GET_MANUAL_PRODUCTION_ENTRY_BY_ID.SUCCESS, {
    selectedManualProductionEntry,
  })

  // Create
  createManualProductionEntry = (payload, callback) => action(manualProductionEntryActionTypes.CREATE_MANUAL_PRODUCTION_ENTRY.REQUEST, {
    payload,
    callback,
  })

  createManualProductionEntryLoading = (createManualProductionEntryLoading) => action(manualProductionEntryActionTypes.CREATE_MANUAL_PRODUCTION_ENTRY.LOADING, {
    createManualProductionEntryLoading,
  })

  // Update
  updateManualProductionEntryStatus = (payload, callback) => action(manualProductionEntryActionTypes.UPDATE_MANUAL_PRODUCTION_ENTRY_STATUS.REQUEST, {
    payload, callback,
  })

  updateManualProductionEntryStatusLoading = (updateManualProductionEntryStatusLoading) => action(manualProductionEntryActionTypes.UPDATE_MANUAL_PRODUCTION_ENTRY_STATUS.LOADING, {
    updateManualProductionEntryStatusLoading,
  })

  // Delete
  deleteManualProductionEntry = (payload, callback) => action(manualProductionEntryActionTypes.DELETE_MANUAL_PRODUCTION_ENTRY.REQUEST, {
    payload, callback,
  })

  /**
   * @param deleteManualProductionEntryLoading
   * @return {{type: *}}
   */
  deleteManualProductionEntryLoading = (deleteManualProductionEntryLoading) => action(manualProductionEntryActionTypes.DELETE_MANUAL_PRODUCTION_ENTRY.LOADING, {
    deleteManualProductionEntryLoading,
  })

}

export default new ManualProductionEntryActions();
